// Chat and detail views share the same source-backed chart presentation.
import type { AnalyticsToolResult } from '../../../../server/services/analytics/types';
import { useCanvasStore } from './canvas-store';
import { AnalyticsReportVisual, ReportSource, type AnalyticsAdRow as AnalyticsBarRow } from './AnalyticsReportView';
export function AnalyticsCard({ result, toolName }: {
    result: AnalyticsToolResult;
    toolName: string;
}) {
    const openSidebarPanel = useCanvasStore(s => s.openSidebarPanel);
    const { renderCard } = result;
    const handleView = () => openSidebarPanel({ type: 'analytics', title: renderCard.title, analyticsData: { ...result, toolName } });
    const handleRowClick = (row: AnalyticsBarRow) => openSidebarPanel({ type: 'analytics', title: row.name, analyticsData: { ...result, toolName, selectedAd: row } });
    return <>
  <div data-testid={`analytics-card-${renderCard.data.cardType}`} style={{ padding: 18, background: '#FFFFFF', border: '1px solid #E1E6EE', borderRadius: 16, marginTop: 12, minWidth: 0, boxShadow: '0 2px 8px #1b1c2004' }}>
   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 12, marginBottom: 12 }}>
    <div style={{ minWidth: 0 }}><div style={{ fontSize: 15, fontWeight: 700, color: '#1B1C20' }}>{renderCard.title}</div><div style={{ fontSize: 11, color: '#5F6D82', marginTop: 4 }}>{renderCard.timeframeLabel}</div></div>
    {renderCard.data.cardType !== 'bar_list' && <button type="button" onClick={handleView} style={{ fontSize: 11, color: '#7D1D46', background: 'transparent', border: 0, cursor: 'pointer', whiteSpace: 'nowrap', padding: '6px 0' }}>View Details →</button>}
   </div>
   <ReportSource result={result}/>
   <AnalyticsReportVisual result={result} onRowClick={handleRowClick}/>
   {result.heartbeatLinks.length > 0 && <div style={{ fontSize: 10, color: '#5F6D82', marginTop: 12 }}>Based on {result.heartbeatLinks.length} saved brand insights.</div>}
  </div>
 </>;
}
